var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddData = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 3H3v2.5h2.5V3zM13 3h-2.5v2.5H13V3zM6.75 3h2.5v2.5h-2.5V3zM5.5 6.75H3v2.5h2.5v-2.5zm1.25 0h2.5v2.5h-2.5v-2.5zM5.5 10.5H3V13h2.5v-2.5zM9.25 12a.75.75 0 0 1 .75-.75h1.25V10a.75.75 0 0 1 1.5 0v1.25H14a.75.75 0 0 1 0 1.5h-1.25V14a.75.75 0 0 1-1.5 0v-1.25H10a.75.75 0 0 1-.75-.75z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddData);
export default ForwardRef;